module.exports = __webpack_public_path__ + "static/impact_5_checker-529d16dab26271c63aa3f8d87c6f9db3.png";